import { render, staticRenderFns } from "./ResetFail.vue?vue&type=template&id=4eab75ce&scoped=true"
import script from "./ResetFail.vue?vue&type=script&lang=js"
export * from "./ResetFail.vue?vue&type=script&lang=js"
import style0 from "./ResetFail.vue?vue&type=style&index=0&id=4eab75ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eab75ce",
  null
  
)

export default component.exports